import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import Http from '../../../Http';
import { objectAsParams } from '../../../helpers';

export default class PagoFacturas extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'pago-factura/one', saveUrl: 'pago-deposito-factura/save', backUrl: false },
      new Form([
        Form.Field('text', 'linea', 'Linea', this.props.linea || '', [], 2, [], [], [], false, true),
        Form.Field('text', 'letra', 'Letra', 'CYC', [], 2, [], [], [], false, true),
        Form.Field('autocomplete', 'id_factura', 'Buscar Folio Factura', '', [Validators.required], 4),
        Form.Field('select', 'id_forma_pago', 'Forma de pago', '', [Validators.required], 4),
        Form.Field('text', 'fecha_vencimiento', 'F. Vencimiento', '', [], 4),
        Form.Field('number', 'importe', 'Valor Factura', '', [Validators.required], 4, [], [], [], false, true),
        Form.Field('select', 'parcial', 'Pago Parcial', '1', [Validators.required], 4, [{ Label: 'Si', Value: '0' }, { Label: 'No', Value: '1' }], [], [], false, false),
        Form.Field('number', 'valor_agregado', 'Valor del Pago', '', [], 4, [], [], [], false, true),
        Form.Field('number', 'g_costo_iva', 'Iva Pagado', '', [], 4, [], [], [], false),
        Form.Field('number', 'g_costo_retencion', 'Retencion Pagada', '', [], 4, [], [], [], false),
      ], ['Agregar Factura'], ''), this.formData
    )
  }

  formData = async (form) => {
    let newForm = form;
    const params = {};
    params["id_plazo"] = this.props.id_plazo
    params["id_pago_deposito"] = this.props.id_pago_deposito
    if (this.facturaFolio) {
      params["factura_folio"] = this.facturaFolio;
      this.facturaFoliod = null;
    }

    const Res = await Http.get(`pago-deposito-factura/form?${objectAsParams(params)}`)
    if (!Res.error) {
      const { facturas, formasPago } = Res.data;
      if (facturas) {
        newForm = Form.FieldOptions(newForm, 'id_factura', facturas, 'id', 'factura_nombre');
      }
      if (formasPago) {
        newForm = Form.FieldOptions(newForm, 'id_forma_pago', formasPago, 'id', 'forma_nombre');
      }
    }

    /* newForm = Form.ValueChange(form, {
      id_factura: this.facturaChange,
      parcial: this.parcialChange,
    }); */
    return newForm;
  }

  parcialChange = (form, field) => {
    const newForm = { ...form }
    newForm.Fields = newForm.Fields.map(f => {
      let newField = {...f};
      if (newField.Name === 'valor_agregado') {
        newField.Disabled = field.Value !== '0'
      }
      return newField;
    })
    return newForm;
  }

  facturaChange = async (form, field) => {
    let newForm = {...form};
    if (field.Value) {
      let Res = await Http.get(`facturas/one/${field.Value}`);
      if (!Res.error) {
        const { linea, fecha_vencimiento, total, g_costo_iva, g_costo_retencion, restante } = Res.data;
        return Form.Patch(newForm, { linea, fecha_vencimiento, importe: total, g_costo_iva, g_costo_retencion, valor_agregado: restante }, true);
      }
    } else {
      this.facturaFolio = field.ValueAt;
      return await this.formData(newForm);
    }
  }

  formChange = async (form, field) => {
    let newForm = { ...form };
    if (field.Name === 'parcial') {
      newForm = this.parcialChange(form, field)
    } else if (field.Name === 'id_factura') {
      newForm = await this.facturaChange(form, field);
    }
    this.setState({ FormData: newForm }) 
  }

  onSubmit = async (i, vals) => {
    this.setState({ loading: true });
    vals.id_pago_deposito = this.props.id_pago_deposito;
    const Res = await Http.post(`${this.config.saveUrl}`, vals);
    if (!Res.error) {
      this.setState({ 
        loading: false, 
        sbMsg: 'Guardado', 
        sbOpen: true, 
        FormData: Form.Reset(this.state.FormData),
      });
      this.props.onSave();
    } else {
      this.setState({ loading: false, sbMsg: `Error al guardar${(Res.errMsg ? `: ${Res.errMsg}` : '')}`, sbOpen: true });
    }
  }

  render() {
    return (
      <this.FormRender />
    )
  }
}
